/*
 * Copyright © 2021, CodeVision. All rights reserved.
 *
 * This file was generated by Codevision's stub generator
 */

export enum Nationality {
  HUNGARIAN = 0,
  SLOVAKIAN = 1,
  ENGLISH = 2,
}

export namespace Nationality {
  export function values() {
    return Object.keys(Nationality).filter((type) => isNaN(type as any) && type !== 'values');
  }
}
